import React, { useState, useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow'

// components
import PreviewWrapper from '../../hoc/PreviewWrapper';

// hooks
import useAuthoringViewStore from '../../../../../hooks/stores/useAuthoringViewStore';

// styles
import './Preview.scss';

const Preview = (props) => {
  const [value, setValue] = useState("");
  const {
    carbonProps
  } = props;

  const {
    forkedFieldsSnakeCase,
    overrideDataSnakeCase,
  } = props.formContext

  const {
    formView,
    showPagePreview,
  } = useAuthoringViewStore(
    useShallow(state => ({
      formView: state.formView,
      showPagePreview: state.showPagePreview,
    })),
  )

  const getValueMapping = (value) => {
    if (props.schema?.valueMapping?.[formView?.id]?.[props.dotNotation]?.[value]) {
      return props.schema.valueMapping[formView.id][props.dotNotation][value]
    }
    return null
  }

  const formatArrayValue = (value) => {
    if (value.length === 0) return ""
    const isArrayOfStrings = value.every(item => typeof item === "string")

    if (isArrayOfStrings) {
      return value.filter(item => !item !== null && !item !== undefined)?.join(", ");
    }

    let options = props?.options?.enumOptions || []
    if (props?.schema?.items?.options) {
      options = props.schema.items.options

      const labels = value.map(val => {
        const found = options.find(option => option.value === val)
        if (found?.label) return found.label
      }).join(", ")
      return labels
    }
  }

  useEffect(() => {
    let jpath = props.id.split(".").join("_")
    if (props.id.indexOf("root_") === 0) jpath = props.id.slice(5)

    let tempVal = null

    if (typeof props?.value === "boolean") {
      if (props.value === true) tempVal = "Yes"
      else tempVal = "No"
    } else if (forkedFieldsSnakeCase?.[formView.id]?.[jpath] || forkedFieldsSnakeCase?.[formView.id]?.[props.id]) {
      tempVal = forkedFieldsSnakeCase[formView.id][jpath] || forkedFieldsSnakeCase?.[formView.id]?.[props.id]
    } else if (overrideDataSnakeCase?.[jpath] || overrideDataSnakeCase?.[props.id]) {
      tempVal = overrideDataSnakeCase?.[jpath] || overrideDataSnakeCase?.[props.id]
    } else if (Array.isArray(props?.value)) {
      tempVal = formatArrayValue(props.value)
    } else if (props.value) {
      tempVal = props.value
    }

    if (props?.schema?.options) {
      const option = props.schema?.options.find(option => option.value == tempVal)

      if (option) {
        tempVal = option.registries?.[formView?.id] ? option.registries[formView.id] : option.label;
      }
    }

    if (typeof tempVal === "string") {
      let valueMapping = getValueMapping(tempVal)
      if (valueMapping) tempVal = valueMapping
      setValue(tempVal)
    }
  }, [props.value, showPagePreview, overrideDataSnakeCase, forkedFieldsSnakeCase])

  return (
    <div
      className="rjs-preview-container rj-widget-container"
      style={carbonProps?.styles?.widgetContainer}>
      <div
        className="rj-widget-title"
        style={carbonProps?.styles?.widgetTitle}>
        {carbonProps?.label || ""}
      </div>
      <div
        className="rj-widget-value"
        style={carbonProps?.styles?.widgetValue}>
        {value || " "}
      </div>
    </div>
  );
};

export default PreviewWrapper(Preview);